import z from 'zod';

import { ContentStatus } from '@addmile/backend-client';

import { COLOR_PRESETS } from '../../const';

export const createCollectionSchema = z.object({
  slug: z.string().min(1, 'Slug is required'),
  title: z.string().min(1, 'Title is required'),
  imageUrl: z.string().url('Invalid URL').optional().or(z.literal('')),
  language: z.enum(['en', 'es']),
  status: z.nativeEnum(ContentStatus),
  personalization: z.string().min(1, 'Collection tag is required'),
  color: z
    .string()
    .min(1, 'Please select a card color')
    .refine((val) => COLOR_PRESETS.includes(val), {
      message: 'Please select a card color',
    }),
});
